var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D1E7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_485_2974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 19.9409C31.5008 21.4561 31.2031 22.9566 30.624 24.3568C30.0449 25.7569 29.1957 27.0293 28.1248 28.1013C27.054 29.1732 25.7825 30.0238 24.3829 30.6043C22.9834 31.1849 21.4832 31.4841 19.968 31.4849C16.8933 31.4339 13.9632 30.1705 11.8155 27.9697C9.6677 25.7689 8.47609 22.8089 8.49999 19.7339C8.50245 16.7947 9.65554 13.9732 11.7124 11.8735C13.7693 9.77385 16.5664 8.5629 19.505 8.49991C19.671 8.49291 19.837 8.48991 20.005 8.48991C21.5131 8.48173 23.008 8.77202 24.4034 9.34404C25.7989 9.91607 27.0674 10.7585 28.1358 11.8229C29.2043 12.8873 30.0516 14.1525 30.629 15.5458C31.2064 16.939 31.5024 18.4328 31.5 19.9409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.7499C12.5012 17.8098 13.6537 14.987 15.7107 12.8863C17.7677 10.7856 20.5656 9.57391 23.505 9.51091C23.671 9.50291 23.837 9.49991 24.005 9.49991C24.283 9.49991 24.5583 9.50957 24.831 9.52891C23.3163 8.83718 21.6701 8.48072 20.005 8.48391C19.837 8.48391 19.671 8.48391 19.505 8.49491C16.5656 8.55791 13.7677 9.76956 11.7107 11.8703C9.65367 13.971 8.50116 16.7938 8.5 19.7339C8.48083 22.6884 9.58133 25.5406 11.5801 27.7165C13.5788 29.8925 16.3275 31.2307 19.273 31.4619C17.2452 30.5015 15.532 28.9847 14.3329 27.0882C13.1338 25.1918 12.4982 22.9937 12.5 20.7499Z",
    fill: "#F599C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 19.9409C31.5008 21.4561 31.2031 22.9566 30.624 24.3568C30.0449 25.7569 29.1957 27.0293 28.1248 28.1013C27.054 29.1732 25.7825 30.0238 24.3829 30.6043C22.9834 31.1849 21.4832 31.4841 19.968 31.4849C16.8933 31.4339 13.9632 30.1705 11.8155 27.9697C9.6677 25.7689 8.47609 22.8089 8.49999 19.7339C8.50245 16.7947 9.65554 13.9732 11.7124 11.8735C13.7693 9.77385 16.5664 8.5629 19.505 8.49991C19.671 8.49291 19.837 8.48991 20.005 8.48991C21.5131 8.48173 23.008 8.77202 24.4034 9.34404C25.7989 9.91607 27.0674 10.7585 28.1358 11.8229C29.2043 12.8873 30.0516 14.1525 30.629 15.5458C31.2064 16.939 31.5024 18.4328 31.5 19.9409Z",
    stroke: "#0058B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.505 8.5C13.505 15 13.505 23.48 19.505 31.48",
    stroke: "#0058B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.505 8.5C26.505 15 26.505 23.477 20.505 31.477",
    stroke: "#0058B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.386 13.4839H29.52",
    stroke: "#0058B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50305 19.4839H31.5001",
    stroke: "#0058B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.98499 25.4839H30.085",
    stroke: "#0058B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_485_2974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.4e5047b8c7995e6f6e80baebb5adec7b.svg";
export { ForwardRef as ReactComponent };